type TipoAlerta = 'SUCCESS' | 'INFO' | 'ERROR';

export class Alerta {
    mensagem: string;
    tipo: TipoAlerta;

    constructor(mensagem: string, tipo: TipoAlerta) {
        this.mensagem = mensagem;
        this.tipo = tipo;
    }

    public equals(other: Alerta | null): boolean {
        return this.mensagem === other?.mensagem && this.tipo === other.tipo;
    }
}
